/*! Kei & Co. — character limit for printed-text fields.
 *
 *  The Mini: Image Upload app has no max-length setting. The text the
 *  customer types here gets PRINTED on the product, so without a cap
 *  someone pastes a paragraph and it cannot be produced.
 *
 *  This caps the field and shows a live counter. It only touches fields
 *  whose own label matches a rule below — the "Anything else we should
 *  know?" note is a message to the shop, not printed text, and must stay
 *  unlimited.
 */
(function () {
  'use strict';

  // label pattern -> maximum characters
  var RULES = [
    { match: /printed/i, limit: 60 }
  ];

  var SEL = 'input[id^="other-field-"], textarea[id^="other-field-"]';
  var MARK = 'keiLimitApplied';

  function ruleFor(input) {
    var label = null;
    try {
      label = document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]');
    } catch (e) { /* fall through */ }
    if (!label) {
      var box = input.closest('.polaris-text-field');
      label = box ? box.querySelector('label') : null;
    }
    var text = label ? (label.textContent || '') : '';
    if (!text) return null;
    for (var i = 0; i < RULES.length; i++) {
      if (RULES[i].match.test(text)) return RULES[i];
    }
    return null;
  }

  function counterFor(input) {
    var wrap = input.closest('.polaris-text-field') || input.parentNode;
    var el = wrap.querySelector('.kei-char-counter');
    if (!el) {
      el = document.createElement('div');
      el.className = 'kei-char-counter';
      el.setAttribute('aria-live', 'polite');
      el.style.cssText =
        'margin-top:4px;font-size:12px;line-height:1.3;text-align:right;opacity:.75';
      wrap.appendChild(el);
    }
    return el;
  }

  function paint(input, limit) {
    var used = (input.value || '').length;
    var el = counterFor(input);
    el.textContent = used + '/' + limit;
    if (used >= limit) {
      el.style.color = '#8A1C1C';
      el.style.opacity = '1';
    } else if (used > limit - 10) {
      el.style.color = '#8A5A00';
      el.style.opacity = '1';
    } else {
      el.style.color = '';
      el.style.opacity = '.75';
    }
  }

  function apply(input) {
    if (!input || input.dataset[MARK]) return;
    var rule = ruleFor(input);
    if (!rule) return;

    input.dataset[MARK] = '1';
    input.setAttribute('maxlength', String(rule.limit));

    // maxlength does not cover a programmatic paste in every browser.
    var trim = function () {
      if ((input.value || '').length > rule.limit) {
        input.value = input.value.slice(0, rule.limit);
      }
      paint(input, rule.limit);
    };

    input.addEventListener('input', trim);
    input.addEventListener('paste', function () { setTimeout(trim, 0); });
    trim();
  }

  function scan(root) {
    try {
      var nodes = (root || document).querySelectorAll(SEL);
      for (var i = 0; i < nodes.length; i++) apply(nodes[i]);
    } catch (e) { /* never break the page */ }
  }

  // The app renders its fields asynchronously, so watch for them.
  function start() {
    scan(document);
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (added[j].nodeType === 1) {
              if (added[j].matches && added[j].matches(SEL)) apply(added[j]);
              scan(added[j]);
            }
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) { /* static scan already ran */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
